import React from "react";

const DonationPage = () => {
  return (
    <section aria-labelledby="donation-heading" className="bg-[#f8fafc] min-h-screen py-12 font-poppins">
      <div className="max-w-8xl mx-auto px-6 lg:px-8">
        {/* TOP BANNER (Hero Style) */}
        <div className="relative w-full h-[280px] md:h-[350px] rounded-[2rem] overflow-hidden shadow-2xl mb-10 group">
          <img
            src="https://static.vecteezy.com/system/resources/thumbnails/073/579/024/small/little-girl-peeks-out-from-behind-old-blue-wooden-door-during-the-daytime-photo.jpeg"
            alt="Donate to Sevaa Foundation for child education, healthcare and social welfare initiatives"
            className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            loading="eager"
            fetchPriority="high"
          />

          {/* Dark Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent"></div>

          {/* Banner Content */}
          <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12 text-white">
            <span className="bg-[#ffb000] text-slate-900 text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 inline-block shadow-lg">
              Support Foundation
            </span>

            <h2 id="donation-heading" className="text-3xl md:text-5xl font-black mb-3 leading-tight">
              Donate For Our Nation & <br className="hidden md:block" />
              Contribute For Society
            </h2>

            <p className="text-slate-200 text-sm md:text-base font-medium max-w-xl">
              Your contribution, no matter how small, has the power to change
              lives and build a brighter future for those in need. Support our NGO today.
            </p>
          </div>
        </div>

        {/* PAYMENT TITLE */}
        <div className="text-center mb-10">
          <h3 className="text-2xl md:text-3xl font-black text-slate-900">
            Choose Payment Method
          </h3>

          <p className="text-slate-500 mt-2 font-medium">
            100% Secure & Transparent Transactions
          </p>
        </div>

        {/* CARDS SECTION
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto">
          
          <div className="bg-white p-8 rounded-[2rem] shadow-lg border border-slate-100 flex flex-col items-center justify-center hover:-translate-y-1 hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-teal-50 rounded-2xl flex items-center justify-center mb-6">
              <svg className="w-8 h-8 text-[#0f766e]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
              </svg>
            </div>

            <h4 className="text-xl font-black text-slate-900 mb-2">
              Scan & Pay (UPI)
            </h4>

            <p className="text-slate-500 text-sm text-center mb-8 px-4">
              Use Google Pay, PhonePe, Paytm, or any UPI app to scan and donate.
            </p>
            
            <div className="bg-white p-4 rounded-3xl border-2 border-dashed border-slate-300 hover:border-[#0f766e] transition-colors relative">
              <span className="absolute -top-2 -left-2 w-4 h-4 border-t-4 border-l-4 border-[#0f766e]"></span>
              <span className="absolute -top-2 -right-2 w-4 h-4 border-t-4 border-r-4 border-[#0f766e]"></span>
              <span className="absolute -bottom-2 -left-2 w-4 h-4 border-b-4 border-l-4 border-[#0f766e]"></span>
              <span className="absolute -bottom-2 -right-2 w-4 h-4 border-b-4 border-r-4 border-[#0f766e]"></span>
              
              <img
                src="https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=DonateNow"
                alt="Sevaa Foundation donation QR code for UPI payment"
                className="w-44 h-44 object-contain"
              />
            </div> 
          </div>

          <div className="bg-white p-8 rounded-[2rem] shadow-lg border border-slate-100 hover:-translate-y-1 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center">
                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
              </div>

              <div>
                <h4 className="text-xl font-black text-slate-900">
                  Bank Transfer
                </h4>
                <p className="text-slate-500 text-sm">
                  Direct transfer through NEFT/RTGS
                </p>
              </div>
            </div>

            <div className="space-y-4">
              {[
                { label: "Bank Name", value: "Canara Bank" },
                { label: "Account Holder", value: "Sevaa Foundation" },
                { label: "Account Number", value: "321784209XXX" },
                { label: "IFSC Code", value: "CNRB000XXXX" },
                { label: "Branch", value: "Indore" },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-xl bg-slate-50 border border-slate-100"
                >
                  <span className="text-slate-500 text-sm font-medium mb-1 sm:mb-0">
                    {item.label}
                  </span>
                  <span className="font-bold text-slate-800 text-sm bg-white px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm">
                    {item.value}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-8 text-center bg-[#0f766e]/10 text-[#0f766e] py-3 rounded-xl font-bold text-sm">
              All donations are tax-exempted under 80G.
            </div>
          </div> 
        </div> */}
      </div>
    </section>
  );
};

export default DonationPage;